var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ui-label tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-font-medium tw-inline-flex",attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }